import { ShareQueryParameter } from '../constants/social';

export const generateUrlWithShareParameter = (
  currentUrl: string | undefined,
  metaTagValues: ShareQueryParameter,
  readyForParameterChaining?: boolean,
) => {
  if (!currentUrl) {
    return '';
  }

  const encodedShareParameter =
    metaTagValues.ogDescription || metaTagValues.ogImageUrl
      ? encodeURIComponent(
          Buffer.from(JSON.stringify(metaTagValues)).toString('base64'),
        )
      : null;

  return encodedShareParameter
    ? `${currentUrl}?share=${encodedShareParameter}${
        readyForParameterChaining ? '&' : ''
      }`
    : `${currentUrl}${readyForParameterChaining ? '?' : ''}`;
};
